import { ENABLE_FAIRE_DIRECT_AUTO_EXTEND_FIRST_ORDER_INCENTIVE_240212 } from "@faire/web-api/indigofair/settings/ENABLE_FAIRE_DIRECT_AUTO_EXTEND_FIRST_ORDER_INCENTIVE_240212";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingEnableFaireDirectAutoExtendFirstOrderIncentive =
  (): boolean => {
    return getSettingValueWithoutAssignment(
      ENABLE_FAIRE_DIRECT_AUTO_EXTEND_FIRST_ORDER_INCENTIVE_240212,
      false
    );
  };
